import { History, ShieldAlert } from "lucide-react";
import { defineFeature } from "../types";

/**
 * Activity log — the workspace-wide audit trail (PRD roadmap item 18, F10).
 *
 * The sidebar entry lives in `CORE_NAV`, so this module only registers the route.
 * Registering it makes `hasRouteFor("activity")` true, which removes the
 * stand-in the router mounts at `/activity` — no edit to router.tsx.
 */
export default defineFeature({
  key: "activity",
  title: "Activity log",
  routes: [{ path: "activity", lazy: () => import("./page") }],
  commands: [
    {
      key: "activity.open",
      label: "Open the activity log",
      icon: History,
      to: "/activity",
      permission: "audit:view",
      group: "navigate",
      keywords: ["audit", "trail", "history", "who changed"],
      description: "Who changed what, when, and from where",
    },
    {
      key: "activity.signins",
      label: "Review failed sign-ins",
      icon: ShieldAlert,
      to: "/activity?action=auth.login_failed",
      permission: "audit:view",
      group: "actions",
      keywords: ["security", "login", "breach", "audit"],
      description: "Every rejected password or 2FA code",
    },
  ],
});
